import {
    Box,
    Collapse,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel, Typography
} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import {Trans} from "../utils/i18n";
import React from "react";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Visibility from '@material-ui/icons/Visibility';
import {InertiaLink, usePage} from "@inertiajs/inertia-react";
import CreateIcon from "@material-ui/icons/Create";
import {makeStyles} from "@material-ui/styles";
import styled from "styled-components";
import {Tooltip} from "@mui/material";


const BadgeStyled = styled.div`
    display: inline-block;
    background-color: rgba(0,0,0,0.1);
    border-radius: 30px;
    padding: .05rem .8rem;
    height: 25.56px;
    //color: white;
`;

const VisibilityIcon = styled(Visibility)`
    vertical-align: bottom;
`;

const BadgeStyleUl = styled.ul`
    margin: 0;
    padding: 1rem;
`;

const BadgeStyleLi = styled.li`
    margin: 0;
    padding: 0;
`;


const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
});

function Row(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);
    const classes = useRowStyles();
    const { returnUrl } = props;
    const { client } = usePage().props;

    return (
        <React.Fragment>
            <TableRow className={classes.root}>
                <TableCell>
                    <IconButton aria-label={<Trans i18nKey="queues.expandRow">expand row</Trans>} size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell component="th" scope="row">
                    {row.number}
                </TableCell>
                {client.key == 'worldpay' && (
                <TableCell component="th" scope="row">
                    {row.batch_reference}
                </TableCell>
                )}
                <TableCell align="left"> {row.service}</TableCell>
                <TableCell align="left">{row.partner?.name}</TableCell>
                {client.key == 'worldpay' && (
                    <TableCell align="left">{row.company?.customer_number}</TableCell>
                )}
                <TableCell align="left">{row.company?.name}</TableCell>
                {client.key !== 'worldpay' && (
                    <TableCell align="left">{row.installation_address?.name}</TableCell>
                )}
                <TableCell align="left">{row.status?.currentStatus?.name}</TableCell>
                <TableCell align="left">{row.status?.currentStatus?.exception}</TableCell>
                <TableCell align="left">{row.created_at}</TableCell>
                {/* <TableCell align="left">{row.client?.name}</TableCell> */}
                <TableCell align="left">
                    <InertiaLink href={route('queue.details', { order: row.order_id, returnUrl: returnUrl })}>
                        <CreateIcon color={'primary'}/>
                    </InertiaLink>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0, width: '100%', }} colSpan={11}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <Typography variant="h6" gutterBottom component="div">
                                <Trans i18nKey="queues.products">Products</Trans>
                            </Typography>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        <TableCell><Trans i18nKey="queues.product">Product</Trans></TableCell>
                                        <TableCell><Trans i18nKey="queues.serialNumber">Serial number</Trans></TableCell>
                                        {client.key == 'worldpay' && (
                                            <TableCell><Trans i18nKey="queues.tid">Terminal ID</Trans></TableCell>
                                        )}
                                        <TableCell align="left"><Trans i18nKey="queues.quantity">Quantity</Trans></TableCell>
                                        {client.key !== 'worldpay' && (
                                            <TableCell><Trans i18nKey="queues.outgoingProduct">Outgoing Product</Trans></TableCell>
                                        )}
                                        {client.key !== 'worldpay' && (
                                            <TableCell><Trans i18nKey="queues.outgoingSerialnummer">Outgoing Serialnumber</Trans></TableCell>
                                        )}
                                        {client.key !== 'worldpay' && (
                                            <TableCell><Trans i18nKey="queues.outgoingQuantity">Outgoing Quantity</Trans></TableCell>
                                        )}
                                        {client.key == 'worldpay' && (
                                            <TableCell><Trans i18nKey="queues.reference">Order Line Reference</Trans></TableCell>
                                        )}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {row.products.map((product) => (
                                        <TableRow key={product.number}>
                                            <TableCell component="th" scope="row">
                                                {product.description}
                                            </TableCell>
                                            <TableCell>{product.serialnumber}</TableCell>
                                            {client.key == 'worldpay' && (
                                                <TableCell>{product.tid}</TableCell>
                                            )}
                                            <TableCell>{product.quantity}</TableCell>
                                            {client.key !== 'worldpay' && (
                                                <TableCell>{product.outgoingDescription}</TableCell>
                                            )}
                                            {client.key !== 'worldpay' && (
                                                <TableCell>
                                                    {
                                                        product.outgoingSerialnumber && (product?.outgoingSerialnumbersList?.length || 1) > 1 &&
                                                        <Tooltip title={<>
                                                            <Trans i18nKey="queueDetail.serialnumbersBelongingToTheProducts">
                                                                Serialnumbers belonging to the products
                                                            </Trans>:
                                                            <BadgeStyleUl>
                                                                {
                                                                    product.outgoingSerialnumbersList.map(item => <BadgeStyleLi key={item.id}>{item.serialnumber}</BadgeStyleLi>)
                                                                }
                                                            </BadgeStyleUl>
                                                        </>
                                                        } placement="top" arrow>
                                                            <BadgeStyled>
                                                                {product.outgoingSerialnumber} <VisibilityIcon />
                                                            </BadgeStyled>
                                                        </Tooltip>
                                                    }
                                                    {
                                                        product.outgoingSerialnumber && (product?.outgoingSerialnumbersList?.length || 1) <= 1 &&
                                                            <BadgeStyled>
                                                                {product.outgoingSerialnumber}
                                                            </BadgeStyled>
                                                    }
                                                </TableCell>
                                            )}
                                            {client.key !== 'worldpay' && (
                                                <TableCell>{product.outgoingQuantity}</TableCell>
                                            )}
                                            {client.key == 'worldpay' && (
                                                <TableCell>{product.reference}</TableCell>
                                            )}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export function QueueTable({ orderBy, orderDirection, setOrderBy, setOrderDirection, results, returnUrl }) {
    const { client } = usePage().props;
    return (

        <TableContainer component={Paper}>
            <Table aria-label={<Trans i18nKey="queues.collapsibleTable">collapsible table</Trans>}>
                <TableHead>
                    <TableRow>
                        <TableCell />
                        <TableCell
                            key={'number'}
                            align={'left'}
                            padding={'normal'}
                            sortDirection={null}
                        >
                            <TableSortLabel
                                active={orderBy === 'number'}
                                direction={orderDirection}
                                onClick={() => {
                                    setOrderBy('number');
                                    setOrderDirection((val) => val === 'asc' ? 'desc' : 'asc');
                                }}
                            >
                                <Trans i18nKey="queues.jobNumber">Job number</Trans>
                            </TableSortLabel>
                        </TableCell>
                        {client.key == 'worldpay' && (
                            <TableCell
                                key={'batch_reference'}
                                align={'left'}
                                padding={'normal'}
                                sortDirection={null}
                            >
                                <TableSortLabel
                                    active={orderBy === 'batch_reference'}
                                    direction={orderDirection}
                                    onClick={() => {
                                        setOrderBy('batch_reference');
                                        setOrderDirection((val) => val === 'asc' ? 'desc' : 'asc');
                                    }}
                                >
                                    <Trans i18nKey="queues.batch_reference">Order Reference</Trans>
                                </TableSortLabel>
                            </TableCell>
                        )}
                        <TableCell
                            key={'services.name'}
                            align={'left'}
                            padding={'normal'}
                            sortDirection={null}
                        >
                            <TableSortLabel
                                active={orderBy === 'services.name'}
                                direction={orderDirection}
                                onClick={() => {
                                    setOrderBy('services.name');
                                    setOrderDirection((val) => val === 'asc' ? 'desc' : 'asc');
                                }}
                            >
                                <Trans i18nKey="queues.service">Service</Trans>
                            </TableSortLabel>
                        </TableCell>
                        <TableCell
                            key={'partners.name'}
                            align={'left'}
                            padding={'normal'}
                            sortDirection={null}
                        >
                            <TableSortLabel
                                active={orderBy === 'partners.name'}
                                direction={orderDirection}
                                onClick={() => {
                                    setOrderBy('partners.name');
                                    setOrderDirection((val) => val === 'asc' ? 'desc' : 'asc');
                                }}
                            >
                                <Trans i18nKey="queues.partner">Partner</Trans>
                            </TableSortLabel>
                        </TableCell>
                        {client.key == 'worldpay' && (
                            <TableCell
                                key={'companies.customer_number'}
                                align={'left'}
                                padding={'normal'}
                                sortDirection={null}
                            >
                                <TableSortLabel
                                    active={orderBy === 'companies.customer_number'}
                                    direction={orderDirection}
                                    onClick={() => {
                                        setOrderBy('companies.customer_number');
                                        setOrderDirection((val) => val === 'asc' ? 'desc' : 'asc');
                                    }}
                                >
                                    <Trans i18nKey="queues.customer_number">MID</Trans>
                                </TableSortLabel>
                            </TableCell>
                        )}
                        <TableCell
                            key={'companies.name'}
                            align={'left'}
                            padding={'normal'}
                            sortDirection={null}
                        >
                            <TableSortLabel
                                active={orderBy === 'companies.name'}
                                direction={orderDirection}
                                onClick={() => {
                                    setOrderBy('companies.name');
                                    setOrderDirection((val) => val === 'asc' ? 'desc' : 'asc');
                                }}
                            >
                                <Trans i18nKey="queues.company">Company</Trans>
                            </TableSortLabel>
                        </TableCell>
                        {client.key !== 'worldpay' && (
                            <TableCell
                                key={'addresses.name'}
                                align={'left'}
                                padding={'normal'}
                                sortDirection={null}
                            >
                                <TableSortLabel
                                    active={orderBy === 'addresses.name'}
                                    direction={orderDirection}
                                    onClick={() => {
                                        setOrderBy('addresses.name');
                                        setOrderDirection((val) => val === 'asc' ? 'desc' : 'asc');
                                    }}
                                >
                                    <Trans i18nKey="queues.customer">Customer</Trans>
                                </TableSortLabel>
                            </TableCell>
                        )}
                        <TableCell
                            key={'statuses.name'}
                            align={'left'}
                            padding={'normal'}
                            sortDirection={null}
                        >
                            <TableSortLabel
                                active={orderBy === 'statuses.name'}
                                direction={orderDirection}
                                onClick={() => {
                                    setOrderBy('statuses.name');
                                    setOrderDirection((val) => val === 'asc' ? 'desc' : 'asc');
                                }}
                            >
                                <Trans i18nKey="queues.status">Status</Trans>
                            </TableSortLabel>
                        </TableCell>
                        <TableCell align="left"><Trans i18nKey="queues.exception">Exception</Trans></TableCell>
                        <TableCell
                            key={'created_at'}
                            align={'left'}
                            padding={'normal'}
                            sortDirection={null}
                        >
                            <TableSortLabel
                                active={orderBy === 'created_at'}
                                direction={orderDirection}
                                onClick={() => {
                                    setOrderBy('created_at');
                                    setOrderDirection((val) => val === 'asc' ? 'desc' : 'asc');
                                }}
                            >
                                <Trans i18nKey="queues.creationDate">Creation date</Trans>
                            </TableSortLabel>
                        </TableCell>
                        {/* <TableCell
                            key={'clients.name'}
                            align={'left'}
                            padding={'normal'}
                            sortDirection={null}
                        >
                            <TableSortLabel
                                active={orderBy === 'clients.name'}
                                direction={orderDirection}
                                onClick={() => {
                                    setOrderBy('clients.name');
                                    setOrderDirection((val) => val === 'asc' ? 'desc' : 'asc');
                                }}
                            >
                                <Trans i18nKey="queues.Client">Client</Trans>
                            </TableSortLabel>
                        </TableCell> */}
                        <TableCell align="left"><Trans i18nKey="queues.action">Action</Trans></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {results.map((row) => (
                        <Row key={row.order_id+row.number} row={row} returnUrl={returnUrl} />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}
